import { Component, inject, OnInit } from '@angular/core';
import { LoginFormComponent } from '../../molecules/login-form/login-form.component';
import { ActiveUserStore } from '../../../stores/user/active-user.state';
import { FooterComponent } from '../../molecules/footer/footer.component';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [LoginFormComponent, FooterComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  readonly userStore = inject(ActiveUserStore);

  async ngOnInit() {
    this.userStore.isLoginActive();
  }
}
